import Vue from 'vue';
import util from './util';

let dateFormat = (value, rule) => {
    return util.formatDate(new Date(value), rule);
}
const checkStatusTable = {
    NoCheck: '未检测',
    Checking: '等待检测',
    Checked: '检测完成',
    Success: '检测成功',
    CheckFail: '检测失败',
    TransFaild: '交易失败',
    OutOfMoney: '余额不足'
};
const accountState = {
    1: '启动',
    0: '冻结',
}
const uploadStatusTable = {
    0: '上传失败',
    1: '上传成功',
};
const DBStatusTable = {
    new: '建库中',
    Indexing: '建库中',
    Indexed: '可使用',
    Incrementing: '增量中',
    CreateFail: '建库失败',
    InCrementFail: '增量失败',
    NotObtain: '未获取',
};
let checkStatus = val => {
    return checkStatusTable[val];
}
let stateFormat = val => {
    return accountState[val];
}
let uploadStatus = val => {
    return uploadStatusTable[val];
}
let DBStatus = val => {
    return DBStatusTable[val];
}
let toStr = val => {
    if (val) {
        return val.join(',');
    }
}
let formatDecimal = val => {
    if (val == 0) {
        return val+'%';
    } else if (isNaN(val)){
        return '0%';
    } else {
        let num = parseFloat(val)*100;
        return num.toFixed(2)+'%';
    }
}
export default {
    dateFormat, checkStatus, stateFormat, uploadStatus, DBStatus, toStr, formatDecimal
}
